import React, { useEffect } from 'react'
import { Routes, Route, useNavigate, useLocation } from 'react-router-dom'
import Projects from './features/projects/pages'
import ProjectsTest from './features/projects/pages/ProjectsTest'
import Editor from './features/editor/pages'
import YouTubePage from './features/youtube/pages'

// OAuth 콜백 리다이렉트 처리 컴포넌트
function OAuthCallback() {
  const navigate = useNavigate()
  const location = useLocation()
  
  useEffect(() => {
    // URL fragment (#) 또는 query parameter (?)에서 토큰 추출
    const hashParams = new URLSearchParams(location.hash.substring(1))
    const queryParams = new URLSearchParams(location.search)
    
    // Supabase code 확인 (운영 환경에서 직접 리다이렉트된 경우)
    const supabaseCode = queryParams.get('code')
    
    // Fragment에서 먼저 확인, 없으면 query parameter 확인
    const accessToken = hashParams.get('access_token') || queryParams.get('access_token')
    const refreshToken = hashParams.get('refresh_token') || queryParams.get('refresh_token')
    const user = queryParams.get('user')
    
    console.log('OAuth Callback - 토큰 확인:', {
      hasAccessToken: !!accessToken,
      hasRefreshToken: !!refreshToken,
      hasUser: !!user,
      hasSupabaseCode: !!supabaseCode,
      fullUrl: window.location.href
    })
    
    if (accessToken) {
      // 토큰을 localStorage에 저장
      localStorage.setItem('access_token', accessToken)
      if (refreshToken) {
        localStorage.setItem('refresh_token', refreshToken)
      }
      if (user) {
        try {
          const userData = JSON.parse(decodeURIComponent(user))
          localStorage.setItem('user', JSON.stringify(userData))
        } catch (e) {
          console.error('사용자 정보 파싱 실패:', e)
        }
      }
      
      // 토큰 저장 후 사용자 정보 가져오기
      console.log('토큰 저장 완료, 사용자 정보 가져오기')
      
      // user 정보가 없으면 API로 가져오기
      if (!user && accessToken) {
        const API_BASE_URL = import.meta.env.VITE_API_BASE_URL || 'http://localhost:8000'
        fetch(`${API_BASE_URL}/api/auth/supabase/user`, {
          headers: {
            'Authorization': `Bearer ${accessToken}`
          }
        })
        .then(res => res.json())
        .then(userData => {
          localStorage.setItem('user', JSON.stringify(userData))
          navigate('/', { replace: true })
        })
        .catch(err => {
          console.error('사용자 정보 가져오기 실패:', err)
          navigate('/', { replace: true })
        })
      } else {
        navigate('/', { replace: true })
      }
    } else if (supabaseCode) {
      // Supabase가 직접 리다이렉트한 경우 - 백엔드에 코드 전달
      console.log('Supabase code 발견, 백엔드로 전달')
      
      // 개발/운영 환경에 따라 백엔드 URL 결정
      const isDev = window.location.hostname === 'localhost'
      const backendUrl = isDev 
        ? 'http://localhost:8000' 
        : 'https://auto-backend-443714712477.us-central1.run.app'
      const frontendUrl = isDev 
        ? 'http://localhost:3000/auth/callback'
        : 'https://app.terai.kr/auth/callback'
      
      window.location.href = `${backendUrl}/api/auth/supabase/kakao/callback?code=${supabaseCode}&state=${encodeURIComponent(frontendUrl)}`
    } else {
      // 토큰이 없으면 백엔드에서 단순 리다이렉트만 한 것
      console.log('토큰이 URL에 없음')
      navigate('/', { replace: true })
    }
  }, [navigate, location])
  
  return <div>로그인 처리 중...</div>
}

function App() {
  return (
    <Routes>
      {/* 메인 페이지 - 프로젝트 목록 */}
      <Route path="/" element={<Projects />} />
      
      {/* 테스트 페이지 - 백엔드 API 연동 테스트 */}
      <Route path="/test/projects-api" element={<ProjectsTest />} />
      
      {/* OAuth 콜백 처리 (백엔드가 여기로 리다이렉트) */}
      <Route path="/auth/callback" element={<OAuthCallback />} />
      
      {/* 영상 편집 페이지 */}
      <Route path="/editor/:projectId" element={<Editor />} />
      
      {/* YouTube 인기 동영상 페이지 */}
      <Route path="/youtube" element={<YouTubePage />} />
    </Routes>
  )
}

export default App